import axios from "axios";
import config from '../config/index';
import {responseIntercept,errorIntercept} from '../utils/interceptor'

export default class Project {
  static instance = axios.create({
    baseURL: config.backendUri + '/api',
    headers:{
      Authorization:'Bearer ' + localStorage.getItem('token')
    }
  });

  static instanceConfig () {
    this.instance.interceptors.request.use(configH => {
      const token = localStorage.getItem('token');
      configH.headers.Authorization = `Bearer ${token}`;
      return configH;
    });
    this.instance.interceptors.response.use(responseIntercept,errorIntercept);

  }

  static async signIn (loginData) {
    const resp = await (await this.instance.post("/signin", loginData)).data;
    return resp;
  }

  static async signUp (userData) {
    const resp = await (await this.instance.post("/signup", userData)).data;
    return resp;
  }

  static async logOut (_id) {
    console.log('user Id disconnected',_id)
    const resp = await (await this.instance.get(`/logout/${_id}`)).data;
    return resp;
  }
  static async getUserQrCode (id) {
    this.instanceConfig();
    const resp = await (await this.instance.get(`user-qr/${id}`)).data;
    return resp;
  }

  static async getUserById (id) {
    this.instanceConfig();
    const resp = await (await this.instance.get(`user-id/${id}`)).data;
    return resp;
  }

  static async updateUser (userInfo) {
    this.instanceConfig();
    const resp = await (await this.instance.put('user', userInfo)).data;
    return resp;
  }

  static async updateUserRole (_id, roleCategory, rolesArray) {
    const resp = await (await this.instance.put("/user-roles", {_id, roleCategory, rolesArray})).data;
    return resp;
  }
  static async updateUserAdmin (_id, admin) {
    const resp = await (await this.instance.put("/user-is-admin", {_id, admin})).data;
    return resp;
  }

  static async deleteUserPermanetly (_id) {
    const resp = await (await this.instance.delete(`/user/${_id}`)).data;
    return resp;
  }

  static async emailDoesExist (email) {
    const resp = await (await this.instance.post(`/user-email-exist`, {email})).data;
    return resp;
  }

}
